import React from "react";
import Pagination from "react-bootstrap/Pagination";

const PaginationComponent = ({ currentPage, totalPages, onPageChange, totalEntries, entriesPerPage }) => {

    const adjustedCurrentPage = currentPage + 1;
    const totalPageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handlePageClick = (page) => {
        if (page !== adjustedCurrentPage) {
            onPageChange(page - 1);
        }
    };

    const startEntry = (adjustedCurrentPage - 1) * entriesPerPage + 1;
    const endEntry = Math.min(adjustedCurrentPage * entriesPerPage, totalEntries);

    return (
        <div className="pagination-section d-sm-flex text-center justify-content-between align-items-center my-2">
            <div className="showing-user">
                <p>
                    Showing {startEntry} to {endEntry} of {totalEntries} entries
                </p>
            </div>
            <div className="pagination-block pt-3">
                <Pagination className="theme-pagination">
                    <Pagination.First
                        onClick={() => handlePageClick(1)}
                        disabled={adjustedCurrentPage === 1}
                        className="theme-pagination-item"
                    />
                    <Pagination.Prev
                        onClick={() => handlePageClick(adjustedCurrentPage - 1)}
                        disabled={adjustedCurrentPage === 1}
                        className="theme-pagination-item"
                    />
                    {totalPageNumbers.map((page) => (
                        <Pagination.Item
                            key={page}
                            active={page === adjustedCurrentPage}
                            onClick={() => handlePageClick(page)}
                            className="theme-pagination-item"
                        >
                            {page}
                        </Pagination.Item>
                    ))}
                    <Pagination.Next
                        onClick={() => handlePageClick(adjustedCurrentPage + 1)}
                        disabled={adjustedCurrentPage === totalPages}
                        className="theme-pagination-item"
                    />
                    <Pagination.Last
                        onClick={() => handlePageClick(totalPages)}
                        disabled={adjustedCurrentPage === totalPages}
                        className="theme-pagination-item"
                    />
                </Pagination>
            </div>
        </div>
    );
};

export default PaginationComponent;
